import { render, staticRenderFns } from "./limittxt.vue?vue&type=template&id=91f19c9e&scoped=true"
import script from "./limittxt.vue?vue&type=script&lang=js"
export * from "./limittxt.vue?vue&type=script&lang=js"
import style0 from "./limittxt.vue?vue&type=style&index=0&id=91f19c9e&prod&lang=scss"
import style1 from "./limittxt.vue?vue&type=style&index=1&id=91f19c9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f19c9e",
  null
  
)

export default component.exports